import { render, staticRenderFns } from "./CuSelect.vue?vue&type=template&id=161f81f4"
import script from "./CuSelect.vue?vue&type=script&lang=js"
export * from "./CuSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports